import 'babel-polyfill';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
//BOOTSTRAP VUE FRAMEWORK
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import BootstrapVue from "bootstrap-vue";

// //AOS Animations
// import AOS from 'aos';
// import 'aos/dist/aos.css';

//FullPage.js Components
import 'fullpage.js/vendors/scrolloverflow'; // Optional. When using scrollOverflow:true
import VueFullPage from 'vue-fullpage.js';

// import axios from 'axios'
// import VueAxios from 'vue-axios'
// import Vuelidate from 'vuelidate'

import VueGtag from "vue-gtag";
import VueTagManager from "vue-tag-manager";
import VueMeta from 'vue-meta';
import inViewportDirective from 'vue-in-viewport-directive';
import VueRellax from 'vue-rellax';

Vue.use(VueRellax);


Vue.use(VueTagManager, {
  gtmId: 'GTM-NZK7XCK'
});

Vue.use(VueGtag, {
  config: { id: "'UA-106440344-2" }
});

//USED FOR IE COMPATIBILITY
require('es6-promise').polyfill();

// AOS.init();

Vue.directive('in-viewport', inViewportDirective);
Vue.use(VueFullPage);
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
});
Vue.use(BootstrapVue);

// Vue.use(Vuelidate)
// Vue.use(VueAxios, axios)
// Vue.prototype.$axios = axios;

Vue.config.productionTip = false;

new Vue({
  router,
  // created () {
  //   AOS.init()
  // },
  render: h => h(App)
}).$mount('#app');